<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<section class="login-section">
  <div class="container">
    <div class="login-container">
      <div class="login-card">
        <div *ngIf="!show2FA">
          <div class="login-header">
            <h1 class="login-title">{{ title | translate }}</h1>
            <p class="login-subtitle">{{ "page.login.subtitle" | translate }}</p>
          </div>

          <!-- Error Alerts -->
          <div class="error-alert" *ngIf="isLoginFailed">
            <span class="error-icon">⚠️</span>
            <span>{{ "page.login.error.wrongCredentials" | translate }}</span>
          </div>
          <div class="error-alert" *ngIf="!isUserVerified">
            <span class="error-icon">⚠️</span>
            <span>{{ "page.login.error.userNotVerified" | translate }}</span>
          </div>

          <!-- Login Form -->
          <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
            <!-- Login Field -->
            <div class="form-group">
              <label for="login" class="form-label">{{ "form.login" | translate }}</label>
              <input
                type="text"
                id="login"
                formControlName="login"
                class="form-input"
                placeholder="John.Doe"
                autocomplete="username"
                maxlength="50"
              />
            </div>

            <!-- Password Field -->
            <div class="form-group">
              <label for="password" class="form-label">{{ "form.password" | translate }}</label>
              <div class="password-input-wrapper">
                <input
                  [type]="showPassword ? 'text' : 'password'"
                  id="password"
                  formControlName="password"
                  class="form-input"
                  autocomplete="current-password"
                  maxlength="255"
                />
                <button type="button" class="password-toggle" (click)="showPassword = !showPassword" tabindex="-1">
                  {{ showPassword ? "👁️" : "👁️‍🗨️" }}
                </button>
              </div>
            </div>

            <!-- Forgot Password / Resend verification link -->
            <div class="form-options">
              <a class="forgot-link" (click)="onForgotPasswordClick($event)" tabindex="0">
                {{ "page.login.resetPassword" | translate }}
              </a>

              <button type="button" cdkFocusInitial *ngIf="!isUserVerified" (click)="resend()" color="primary" class="resend-link">
                {{ "page.registration.resend.title" | translate }}
              </button>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="login-button" [disabled]="loginForm.disabled">
              <span>
                {{ (loginForm.disabled ? "page.login.loading" : "button.login") | translate }}
              </span>
            </button>
          </form>

          <!-- Disconnect Option -->
          <div class="logout" *ngIf="isModal">
            <a (click)="logout($event)" class="link-primary" tabindex="0">
              {{ "page.login.logout" | translate }}
            </a>
          </div>

          <!-- Sign Up Link -->
          <div class="signup-link" *ngIf="!isModal">
            <p>
              {{ "page.login.noAccount" | translate }}
              <a routerLink="/registration" routerLinkActive="active" class="link-primary">
                {{ "button.signup" | translate }}
              </a>
            </p>
          </div>
        </div>

        <!-- 2FA Verification Form -->
        <div *ngIf="show2FA">
          <div class="login-header">
            <h1 class="login-title">{{ "page.login.2fa.title" | translate }}</h1>
            <p class="login-subtitle">{{ "page.login.2fa.description" | translate }}</p>
          </div>

          <!-- Error Alert -->
          <div class="error-alert" *ngIf="is2FAFailed">
            <span class="error-icon">⚠️</span>
            <span>{{ "page.login.2fa.wrongCode" | translate }}</span>
          </div>

          <!-- 2FA Form -->
          <form [formGroup]="digits2FAForm" (ngSubmit)="onSubmit()" class="login-form">
            <!-- 2FA Code Inputs -->
            <div class="code-inputs-container" formArrayName="digits">
              <input
                #digitInput
                *ngFor="let d of digitsFormArray.controls; let i = index"
                type="text"
                [formControlName]="i"
                class="code-input-digit"
                [id]="'digitInput' + i"
                maxlength="1"
                placeholder="-"
                inputmode="numeric"
                (input)="onDigitInput($event, i)"
                (keydown)="onKeyDown($event, i)"
                (paste)="pasteEvent($event, i)"
                autocomplete="off"
              />
            </div>

            <!-- Verify Button -->
            <button type="submit" class="login-button" [disabled]="digits2FAForm.disabled">
              <span>
                {{ (digits2FAForm.disabled ? "page.login.2fa.loading" : "button.login") | translate }}
              </span>
            </button>

            <!-- Back to Login -->
            <div class="back-to-login">
              <a (click)="goBack()" class="link-primary" tabindex="0"> ← {{ "button.back" | translate }} </a>
            </div>

            <!-- Resend Code Link -->
            <div class="resend-code">
              <a (click)="onSubmit(true)" class="link-secondary" tabindex="0">
                {{ "page.login.2fa.resendCode" | translate }}
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
